import singleChart from './single-chart'

export default {
  namespaced: true,
  modules: {
    bar: singleChart,
    pie: singleChart
  }
}
